module.exports = __webpack_public_path__ + "static/media/display-suite-07.2f619fce.jpg";